<template>
  <div v-if="brand.textLogo" class="flex h-10 items-center gap-2 px-2">
    <img :src="brand.icon" alt="" class="size-7 object-contain">
    <img :src="brand.textLogo" :alt="brand.name" class="h-6 min-w-0 object-contain object-left">
  </div>
  <ui-sidebar-brand
    v-else
    :logo="brand.icon"
    :title="brand.name"
    subtitle="by Infinite∞Tools"
  />
</template>

<script>
import mainLogo from '@/assets/img/icons/main-logo.svg';
import mtuLogoCrest from '@/assets/img/mtu-logo-crest.svg';
import mtuLogoText from '@/assets/img/mtu-logo-text.svg';
import shoprenterLogoIcon from '@/assets/img/shoprenter-logo-icon.svg';
import shoprenterLogoText from '@/assets/img/shoprenter-logo-text.svg';

const BRANDS = {
  turisztikai: { icon: mtuLogoCrest, textLogo: mtuLogoText, name: 'MTÜ' },
  shoprenter: { icon: shoprenterLogoIcon, textLogo: shoprenterLogoText, name: 'Shoprenter' },
  default: { icon: mainLogo, textLogo: null, name: 'Ad' },
};

/** The app's logo and name for the current fork. */
export default {
  name: 'AppBrandMark',
  computed: {
    brand() {
      return BRANDS[process.env.VUE_APP_FORK] || BRANDS.default;
    },
  },
};
</script>
